/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ErrorMessage from "../../components/ErrorMessage";
import FormInput from "../../components/FormInput";
import FormLabel from "../../components/FormLabel";
import SimpleButton from "../../components/SimpleButton";
import Spacer from "../../components/Spacer";
import { IApplicationState } from "../../store";
import {
  changePasswordDraftUpdate,
  changePasswordSaveRequest,
} from "../../store/authentication/slice";
import { IChangePassword } from "../../store/authentication/types";

import { Container } from "./styles";

const UserChangePasswordForm: React.FC = () => {
  const { t } = useTranslation();

  const changePassword = useSelector(
    (state: IApplicationState) => state.authentication
  );

  const dispatch = useDispatch();

  const editingChangePassword = changePassword.draftChangePassword;

  const setEditingChangePassword = useCallback(
    (password: IChangePassword) => {
      dispatch(changePasswordDraftUpdate(password));
    },
    [dispatch]
  );

  if (!editingChangePassword) {
    return (
      <Container>
        <h1>{t("pages.change_password.not_found_form")}</h1>
      </Container>
    );
  }

  return (
    <Container>
      <h1>{t("pages.change_password.reset_password")}</h1>

      <FormLabel>{t("pages.change_password.password")}</FormLabel>
      <FormInput
        type="password"
        value={editingChangePassword.password || ""}
        onChangeText={(text) => {
          setEditingChangePassword({
            ...editingChangePassword,
            password: text,
          });
        }}
      />
      <FormLabel>{t("pages.change_password.new_password")}</FormLabel>
      <FormInput
        type="password"
        value={editingChangePassword.newPassword || ""}
        onChangeText={(text) => {
          setEditingChangePassword({
            ...editingChangePassword,
            newPassword: text,
          });
        }}
      />
      <FormLabel>{t("pages.change_password.confirmation_password")}</FormLabel>
      <FormInput
        type="password"
        value={editingChangePassword.confirmationPassword || ""}
        onChangeText={(text) => {
          setEditingChangePassword({
            ...editingChangePassword,
            confirmationPassword: text,
          });
        }}
      />

      <Spacer size={20} />

      <SimpleButton
        prependIcon="save"
        color="primary"
        disabled={editingChangePassword?.isSaving || changePassword.isLoading}
        onClick={() => {
          dispatch(changePasswordSaveRequest(editingChangePassword));
        }}
      >
        {editingChangePassword?.isSaving
          ? `${t("common.buttons.saving")}...`
          : t("common.buttons.save")}
      </SimpleButton>

      <Spacer size={20} />

      {editingChangePassword?.error && (
        <React.Fragment>
          <ErrorMessage>{editingChangePassword.error.message}</ErrorMessage>
          <Spacer size={20} />
        </React.Fragment>
      )}
    </Container>
  );
};

export default UserChangePasswordForm;
